import { extractUsernameFromURL } from "../utils/helpers";

export const PROJECT_NAME = "SkillChampp";
export const PROJECT_SUBTITLE = `Join ${PROJECT_NAME} to master in-demand skills like e-commerce store administration, freelancing and more. Work from home and start earning $1000+/month.`;
export const PROJECT_URL = "https://skillchampp.com";
export const PROJECT_URL_SHORT = "skillchampp.com";

export const ADMIN_BANK_NAME = "Faysal Bank Limited";
export const ADMIN_BANK_ACCOUNT_TITLE = "Asad Javed";
export const ADMIN_BANK_ACCOUNT_NUMBER = "3140436000007794";
export const ADMIN_BANK_IBAN = "PK22FAYS3140436000007794";

export const CONTACT_EMAIL = "skillchampp@gmail.com";
export const CONTACT_PHONE_NUMBER = "+9203167166004";

export const DISCORD_SOCIAL_URL = "https://discord.com/-----";
export const FACEBOOK_SOCIAL_URL = "https://www.facebook.com/share/16HCazWiNb/?mibextid=wwXIfr";
export const INSTAGRAM_SOCIAL_URL = "https://instagram.com/skillchampp";
export const TIKTOK_SOCIAL_URL = "https://tiktok.com/@skillchampp";
export const TWITTER_X_SOCIAL_URL = "https://x.com/skillchampp";
export const YOUTUBE_SOCIAL_URL = "https://youtube.com/@SkillChamppOfficial";

export const TWITTER_X_SOCIAL_HANDLE = extractUsernameFromURL(TWITTER_X_SOCIAL_URL); // for landing page metadata

// Recycled

// export const PROJECT_NAME = "LMS Platform";
// export const PROJECT_SUBTITLE = "Learn something new";
// export const PROJECT_URL_SHORT = "lms-platform-hammadxp.vercel.app";
// export const PROJECT_URL =
//   process.env.NODE_ENV === "production" ? "https://lms-platform-hammadxp.vercel.app" : "http://localhost:3000";

// export const ADMIN_SUBTITLE = "An e-commerce expert with niche skills";

// export const ADMIN_FIRST_NAME = "Hammad";
// export const ADMIN_LAST_NAME = "Javed";
// export const CONTACT_PHONE_NUMBER = "+92 0317 0758582";

// export const DISCORD_SOCIAL_URL = "https://discord.com/lms-platform";

// 13 Apr 2025
// export const CONTACT_PHONE_NUMBER = "+9203107877460";

// 15 Apr 2025
// export const CONTACT_EMAIL = "learnwithasad7@gmail.com";

// 20 Apr 2025
// export const PROJECT_URL = process.env.NODE_ENV === "development" ? "http://localhost:3000" : "https://learnwithasad.co";

// 25 Apr 2025
// export const PROJECT_SUBTITLE = "Learn something new";

// 04 Aug 2025
// export const WHATSAPP_DEFAULT_MESSAGE = "Hi, I have a question!";

// 28 Mar 2026

// export const PROJECT_NAME = "Learn With Asad";
// export const PROJECT_URL = "https://learnwithasad.co";
// export const PROJECT_URL_SHORT = "learnwithasad.co";

// export const ADMIN_FIRST_NAME = "Asad";
// export const ADMIN_LAST_NAME = "Javed";

// export const ADMIN_BANK_ACCOUNT_NUMBER = "3140307000002251";
// export const ADMIN_BANK_IBAN = "PK94FAYS3140307000002251";

// export const CONTACT_EMAIL = "learnwithasadlive@gmail.com";

// export const INSTAGRAM_SOCIAL_URL = "https://instagram.com/learnwithasadlive";
// export const TIKTOK_SOCIAL_URL = "https://tiktok.com/@learnwithasadlive";
// export const YOUTUBE_SOCIAL_URL = "https://youtube.com/@learnwithasadlive";

// export const TWITTER_X_SOCIAL_HANDLE = "LearnWithAsad";
